import type { CatalogItem } from '~/models/common'

export const userOffer: CatalogItem[] = [
  {
    label: 'AR/VR',
    value: 1,
  },
  {
    label: 'Art',
    value: 2,
  },
  {
    label: 'Sound',
    value: 21,
  },
  {
    label: 'Consultancy',
    value: 3,
  },
  {
    label: 'Development (Blockchain)',
    value: 4,
  },
  {
    label: 'Development (mobile)',
    value: 5,
  },
  {
    label: 'Development (PC/console)',
    value: 6,
  },
  {
    label: 'Distribution',
    value: 7,
  },
  {
    label: 'Game Testing',
    value: 8,
  },
  {
    label: 'Investment',
    value: 9,
  },
  {
    label: 'Licensing',
    value: 10,
  },
  {
    label: 'Localisation',
    value: 11,
  },
  {
    label: 'Marketing',
    value: 12,
  },
  {
    label: 'Media Coverage',
    value: 13,
  },
  {
    label: 'Monetization',
    value: 14,
  },
  {
    label: 'Publishing (PC)',
    value: 15,
  },
  {
    label: 'Publishing (mobile)',
    value: 16,
  },
  {
    label: 'Tools & Services',
    value: 17,
  },
  {
    label: 'User Acquisition',
    value: 18,
  },
  {
    label: 'Game Stores',
    value: 19,
  },
  {
    label: 'Recruitment',
    value: 22,
  },
  {
    label: 'HTML5 games',
    value: 23,
  },
  {
    label: 'Mobile games',
    value: 24,
  },
  {
    label: 'PC/Console Games',
    value: 25,
  },
  {
    label: 'Other',
    value: 20,
  },
  {
    label: 'UA Creatives',
    value: 26,
  },
  {
    label: 'Game Design',
    value: 27,
  },
]
